import {isFeatureEnabled} from 'feature-flags';

import {featureFlags} from '@dms/feature-flags';

/**
 * The read state of customer messages (markers, opened on view, badges, counts) belongs to the
 * synchronized thread, so it follows MESSAGE_SYNCHRONIZATION.
 */
export function useIsCommunicationReadStateEnabled() {
  return isFeatureEnabled(featureFlags.MESSAGE_SYNCHRONIZATION);
}
